import React from 'react';

interface TestimonialProps {
  name: string;
  role: string;
  image: string;
  quote: string;
  rating: number;
}

const StarIcon: React.FC<{ filled: boolean }> = ({ filled }) => (
  <div className="w-3 h-3 relative overflow-hidden flex-shrink-0">
    <svg
      className={`absolute inset-0 w-full h-full ${filled ? 'text-yellow-400' : 'text-gray-300'}`}
      fill="currentColor"
    >
      <path d="M6 2l1.5 3h3.5L8.5 7l1 3.5L6 8.5 2.5 10.5l1-3.5L1 5h3.5z" />
    </svg>
  </div>
);

const TestimonialCard: React.FC<TestimonialProps> = ({ name, role, image, quote, rating }) => {
  console.log('Rendering testimonial for:', name);
  
  return (
    <div className="bg-white p-6 rounded-xl shadow-md transform transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
      <div className="flex items-center mb-3">
        <img
          src={image}
          alt={name}
          className="w-8 h-8 rounded-full object-cover mr-3"
        />
        <div>
          <h4 className="font-semibold text-lynx-primary text-sm">{name}</h4>
          <p className="text-xs text-gray-600">{role}</p>
        </div>
      </div>
      <div className="flex items-center gap-0.5 mb-2">
        {[...Array(5)].map((_, i) => (
          <StarIcon key={i} filled={i < rating} />
        ))}
      </div>
      <p className="text-sm text-gray-700 italic leading-relaxed">{quote}</p>
    </div>
  );
};

const Testimonials: React.FC = () => {
  const testimonials = [
    {
      name: "Sarah Chen",
      role: "Piano Student",
      image: "https://i.pravatar.cc/150?img=1",
      quote: "LessonLynx made it so easy to find the perfect piano teacher. The scheduling system is fantastic, and I love being able to track my progress!",
      rating: 5
    },
    {
      name: "Michael Rodriguez",
      role: "Guitar Teacher",
      image: "https://i.pravatar.cc/150?img=2",
      quote: "As a music teacher, LessonLynx has transformed how I manage my teaching business. The platform handles all the administrative work so I can focus on teaching.",
      rating: 5
    },
    {
      name: "Emma Thompson",
      role: "Violin Student",
      image: "https://i.pravatar.cc/150?img=3",
      quote: "The video lesson feature is amazing! Even when I can't make it to in-person lessons, I can still learn effectively from home.",
      rating: 4
    },
    {
      name: "David Kim",
      role: "Voice Teacher",
      image: "https://i.pravatar.cc/150?img=4",
      quote: "The secure payment system and scheduling tools have made my teaching business much more professional. My students love the platform too!",
      rating: 5
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-lynx-primary mb-4">
            What Our Community Says
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Join thousands of satisfied students and teachers who are already part of the LessonLynx community.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard
              key={index}
              {...testimonial}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials; 